import { type FC } from 'react';
import { CartTempRegistration } from '@/registration/hook/useGroupShoppingCart';
import {
  UiHStack,
  UiIconCheck,
  UiIconList,
  UiIconListMagnifyingGlass,
  UiIconPlus,
  UiIconX,
  UiStack, uiStyles,
  UiTag,
  UiText,
} from '@/lib/ui';
import BaseBlockList from '@/base/BlockList';
import BaseButtonPlainIcon from '@/base/Button/PlainIcon';
import type { TempRegistration } from '@/api/registration';

export interface TicketRegistrationsProps {
  addedRegistrations: TempRegistration[],
  availableRegistrations: TempRegistration[],
  onAddRegistration: (registration: TempRegistration) => void,
  onRemoveRegistration: (registration: TempRegistration) => void,
}

const TicketRegistrations: FC<TicketRegistrationsProps> = ({
  addedRegistrations,
  availableRegistrations,
  onAddRegistration,
  onRemoveRegistration,
}) => {

  return (
    <UiStack
      spacing={8}
      flexGrow={1}
    >
      <UiStack flexGrow={1}>
        <UiHStack>
          <UiIconCheck color={'green.500'} size={'2xl'}/>
          <UiText fontWeight={'bold'} color={'green.500'}>Added attendees</UiText>
        </UiHStack>
        {addedRegistrations.length === 0 && (
          <UiHStack justifyContent={'flex-start'}>
            <UiText>None</UiText>
          </UiHStack>
        )}
        {addedRegistrations.length > 0 && (
          <UiStack
            borderRadius={uiStyles.borderRadius}
            borderColor={'green.100'}
            borderStyle={'solid'}
            borderWidth={'1px'}
            bgColor={'green.50'}
            p={2}
          >
            <BaseBlockList bgColor={'#fff'} enableDivider={true}>
              {addedRegistrations.map((registration) => {
                return (
                  <UiHStack
                    key={registration.id}
                    justifyContent={'space-between'}
                    px={{base: 4, lg: 8}}
                    py={4}
                    onClick={() => {
                      onRemoveRegistration(registration);
                    }}
                    {...uiStyles.hover}
                  >
                    <UiStack>
                      <UiText>{`${registration.firstName} ${registration.lastName}`}</UiText>
                      {/*<UiText variant={'body2'} color={'text.secondary'}>{registration.email}</UiText>*/}
                    </UiStack>
                    <BaseButtonPlainIcon
                      label={'Remove'}
                      color={'red.500'}
                      Icon={UiIconX}
                      // onClick={() => {
                      //   onRemoveRegistration(registration);
                      // }}
                    />
                  </UiHStack>
                );
              })}
            </BaseBlockList>
          </UiStack>
        )}
      </UiStack>
      <UiStack>
        <UiHStack>
          <UiIconListMagnifyingGlass color={'text.primary'} size={'2xl'}/>
          <UiText fontWeight={'bold'}>Available attendees</UiText>
        </UiHStack>
        {availableRegistrations.length === 0 && (
          <UiHStack justifyContent={'flex-start'}>
            {/*<UiTag colorScheme={'yellow'}>None</UiTag>*/}
            <UiText>None</UiText>
          </UiHStack>
        )}
        {availableRegistrations.length > 0 && (
          <BaseBlockList bgColor={'#fff'} enableDivider={true}>
            {availableRegistrations.map((registration) => {
              return (
                <UiHStack
                  key={registration.id}
                  justifyContent={'space-between'}
                  px={{base: 4, lg: 8}}
                  py={4}
                  {...uiStyles.hover}
                  opacity={registration.disabled ? 0.5 : 1}
                  {...!registration.disabled && { onClick: () => { onAddRegistration(registration); } }}
                >
                  <UiText>{`${registration.firstName} ${registration.lastName}`}</UiText>
                  <BaseButtonPlainIcon
                    label={'Add'}
                    color={'primary.500'}
                    Icon={UiIconPlus}
                    // onClick={() => {
                    //   onAddRegistration(registration);
                    // }}
                  />
                </UiHStack>
              );
            })}
          </BaseBlockList>
        )}
      </UiStack>
    </UiStack>
  );
};

export default TicketRegistrations;
